export const ManualFormHash = {
  networkInformation: "networkInformation",
  accessControl: "accessControl",
} as const;

export type ManualFormHashType =
  (typeof ManualFormHash)[keyof typeof ManualFormHash];
